"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var context_1 = require("./context");
var uuid_1 = require("uuid");
var layout_1 = require("../../layout");
var Toast_1 = __importDefault(require("./Toast"));
var PLACEMENT_TO_FLEX_PROPS = {
    topLeft: {
        direction: 'column',
        alignItems: 'flex-start',
    },
    bottomLeft: {
        direction: 'column-reverse',
        alignItems: 'flex-start',
    },
    top: {
        direction: 'column',
        alignItems: 'center',
    },
    bottom: {
        direction: 'column-reverse',
        alignItems: 'center',
    },
    topRight: {
        direction: 'column',
        alignItems: 'flex-end',
    },
    bottomRight: {
        direction: 'column-reverse',
        alignItems: 'flex-end',
    },
};
var ToastTray = function (_a) {
    var placement = _a.placement, toastMap = _a.toastMap, dismiss = _a.dismiss;
    var items = react_2.useMemo(function () { return Object.values(toastMap).filter(function (t) { return (t.placement || 'topRight') === placement; }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ).map(function (_a) {
        var key = _a.key, timerId = _a.timerId, duration = _a.duration, _placement = _a.placement, toastProps = __rest(_a, ["key", "timerId", "duration", "placement"]);
        return (react_1.jsx(Toast_1.default, __assign({}, toastProps, { key: key, onDismiss: function () {
                var _a;
                dismiss(key || '');
                (_a = toastProps.onDismiss) === null || _a === void 0 ? void 0 : _a.call(toastProps);
            } })));
    }); }, [placement, toastMap, dismiss]);
    return (react_1.jsx(layout_1.Flex, __assign({}, PLACEMENT_TO_FLEX_PROPS[placement], { gap: 16, css: { width: '100%', height: '100%' } }), items));
};
var ToastProvider = function (_a) {
    var children = _a.children;
    var _b = react_2.useState({}), toastMap = _b[0], setToastMap = _b[1];
    var dismiss = react_2.useCallback(function (key) {
        setToastMap(function (prev) {
            var _a, _b;
            if ((_a = prev[key]) === null || _a === void 0 ? void 0 : _a.timerId) {
                window.clearTimeout((_b = prev[key]) === null || _b === void 0 ? void 0 : _b.timerId);
            }
            var nextValue = __assign({}, prev);
            delete nextValue[key];
            return nextValue;
        });
    }, [setToastMap]);
    var show = react_2.useCallback(function (_a) {
        var _b = _a.key, key = _b === void 0 ? uuid_1.v4() : _b, _c = _a.duration, duration = _c === void 0 ? 4500 : _c, args = __rest(_a, ["key", "duration"]);
        var timerId = duration
            ? window.setTimeout(function () { return dismiss(key); }, duration)
            : undefined;
        setToastMap(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = __assign({ key: key, timerId: timerId, duration: duration }, args), _a)));
        });
        return key;
    }, [setToastMap, dismiss]);
    var contextValue = react_2.useMemo(function () { return ({ show: show, dismiss: dismiss }); }, [show, dismiss]);
    return (react_1.jsx(context_1.ToastContext.Provider, { value: contextValue },
        react_1.jsx(layout_1.Grid, { templateRows: "1fr 1fr", templateColumns: "1fr 1fr 1fr", css: {
                position: 'fixed',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                zIndex: 100,
                pointerEvents: 'none',
                padding: 16,
            } },
            react_1.jsx(layout_1.Grid.Cell, { row: "1", column: "1" },
                react_1.jsx(ToastTray, { placement: "topLeft", toastMap: toastMap, dismiss: dismiss })),
            react_1.jsx(layout_1.Grid.Cell, { row: "1", column: "2" },
                react_1.jsx(ToastTray, { placement: "top", toastMap: toastMap, dismiss: dismiss })),
            react_1.jsx(layout_1.Grid.Cell, { row: "1", column: "3" },
                react_1.jsx(ToastTray, { placement: "topRight", toastMap: toastMap, dismiss: dismiss })),
            react_1.jsx(layout_1.Grid.Cell, { row: "2", column: "1" },
                react_1.jsx(ToastTray, { placement: "bottomLeft", toastMap: toastMap, dismiss: dismiss })),
            react_1.jsx(layout_1.Grid.Cell, { row: "2", column: "2" },
                react_1.jsx(ToastTray, { placement: "bottom", toastMap: toastMap, dismiss: dismiss })),
            react_1.jsx(layout_1.Grid.Cell, { row: "2", column: "3" },
                react_1.jsx(ToastTray, { placement: "bottomRight", toastMap: toastMap, dismiss: dismiss }))),
        children));
};
exports.default = ToastProvider;
